import { SerializedStyles, css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const connectionStatusDotStyles = (installed: boolean): SerializedStyles =>
  css({
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    backgroundColor: installed ? withVar(DesignToken.ActionPositiveDefault) : withVar(DesignToken.ActionNeutralDefault),
  });
